import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const DrawerTitle = ({ className , children  })=>/*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "smallest",
        className: classnames('drawer-title', className)
    }, children)
;

export { DrawerTitle };
//# sourceMappingURL=DrawerTitle.js.map
